import markOrderReady from '../../../axios/wolt/orders'
import { logger } from '../../../../logger/logger'

export const markOrderReadyThunk = (orderId) => async () => {
	try {
		await markOrderReady(orderId)
		return true
	} catch (error) {
		logger.warn('[MarkReady] Failed to mark order as ready', { orderId, error: error?.message ?? String(error) })
		return false
	}
}
